import {
    getAssessmentInfo,
    updateAssessmentInfo
} from "./api";
import { Height } from "../../../../domain/assessment/Height";
import { Weight } from "../../../../domain/assessment/Weight";
import { LifeStatus } from "../../../../domain/assessment/LifeStatus";
import { FamilyDistance } from "../../../../domain/assessment/FamilyDistance";
import { NursingDegree } from "../../../../domain/assessment/NursingDegree";
import { Disease } from "../../../../domain/assessment/Disease";
import { OtherDiseases } from "../../../../domain/assessment/OtherDiseases";
import { CareRecipientId } from "../../../../domain/care_recipient/CareRecipientId";
import { createAsyncThunk, createAction } from "@reduxjs/toolkit";
import { orderErrorToast, orderSuccessToast } from "../../../../app/funcs/orderResultToast";

export const ActionType = Object.freeze({
    base: "@@Monitoring/Action/Assessment/Info",
    get: "get",
    update: "update",
    init: "init"
});

export const getAssessmentInfoAction = createAsyncThunk(
    `${ActionType.base}/${ActionType.get}`,
    async (careRecipientId: CareRecipientId, { rejectWithValue }) => {
        const response = await getAssessmentInfo(careRecipientId);

        if (response.error === undefined) {
            // API処理結果正常の場合
            return { ...response };
        } else {
            // API処理結果異常の場合
            return rejectWithValue({});
        }
    }
);

export const updateAssessmentInfoAction = createAsyncThunk(
    `${ActionType.base}/${ActionType.update}`,
    async (data: {
        careRecipientId: CareRecipientId,
        height: Height,
        weight: Weight,
        weekdayLifeStatus: LifeStatus | undefined,
        holidayLifeStatus: LifeStatus | undefined,
        familyDistance: FamilyDistance | undefined,
        nursingDegree: NursingDegree | undefined,
        sufferedDisease: (Disease | undefined)[],
        otherSufferedDiseases: OtherDiseases,
        diuretic: boolean,
        bathAtHome: boolean,
    }, { rejectWithValue }) => {
        const response = await updateAssessmentInfo(
            data.careRecipientId,
            data.height,
            data.weight,
            data.weekdayLifeStatus,
            data.holidayLifeStatus,
            data.familyDistance,
            data.nursingDegree,
            data.sufferedDisease,
            data.otherSufferedDiseases,
            data.diuretic,
            data.bathAtHome
        );

        if (response.error === undefined) {
            // API処理結果正常の場合
            orderSuccessToast("利用者情報を更新しました");
            return {};
        } else {
            // API処理結果異常の場合
            orderErrorToast("利用者情報の更新に失敗しました");
            return rejectWithValue({});
        }
    }
);

export const initAssessmentInfoAction = createAction(
    `${ActionType.base}/${ActionType.init}`
);
